const BASE = ['banking-integrations'];

export const BANKING_INTEGRATIONS_QUERY_KEYS = {
  getActionMappings: () => [...BASE, 'mappings'],
};
